import { createRedesignEntry } from "../redesign-page-entry";

export default createRedesignEntry(() => import("./profile-view-page"), {
  testId: "rd-profile-loading",
  // «Мой профиль» is a top-level destination reached from the account menu. The breadcrumb only starts
  // showing once you go FURTHER, into a sub-page (Add clinic, Edit profile, …), each of which passes its
  // own `breadcrumbRoot: { id: "redesign.profile.title", to: "/pages/my_account" }`.
});
